import { create } from "zustand";

interface AppState {
  selectedInboxId: number | null;
  selectedChannelFilter: number | null;
  sidebarCollapsed: boolean;
  mobileSidebarOpen: boolean;
  setSelectedInbox: (id: number | null) => void;
  setSelectedChannelFilter: (id: number | null) => void;
  toggleSidebar: () => void;
  setMobileSidebarOpen: (open: boolean) => void;
}

export const useAppStore = create<AppState>()((set) => ({
  selectedInboxId: null,
  selectedChannelFilter: null,
  sidebarCollapsed: false,
  mobileSidebarOpen: false,
  setSelectedInbox: (id) => set({ selectedInboxId: id }),
  setSelectedChannelFilter: (id) => set({ selectedChannelFilter: id }),
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
  setMobileSidebarOpen: (open) => set({ mobileSidebarOpen: open }),
}));
